import React from "react";
import EntityModalButton from "../entityProfileModal/components/EntityModalButton";
import ProfileWindowSettingsModal from "./ProfileWindowSettingsModal";

/**
 * Sits next to Export Profile in both profile window headers. The legacy
 * AngularJS headers render the equivalent button in their own templates and
 * mount `ProfileWindowSettingsModal` through `reactProfileWindowSettingsModal`.
 */
export default function ProfileWindowSettingsButton() {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      <EntityModalButton
        aria-label="Profile window settings"
        iconClassName="fa fa-sliders"
        kind="blue"
        size="sm"
        title="Profile window settings"
        onClick={() => setIsOpen(true)}
      />
      {isOpen ? <ProfileWindowSettingsModal onClose={() => setIsOpen(false)} /> : null}
    </>
  );
}
